
// instagram
//--------------------------------------------------------------------
$(function() {
    var insta_media_limit = '20';
    var insta_business_id = '17841403953714011';
    var insta_access_token = 'EAAGD3sOwHPYBABNHdlJG56kDPHuW5ZC8SA8Ka5MmrHrIPzGrMBOFqHabshQOxcRmTzcmoXZCPJdlxSgdPuaRp4oNJ7K1HauDHVmHr0teIgbOZCyGnLw5sNqzQdmDqjCnnoqBxnOuzZCxt9j7SzzGQddHiHQasipNSFgkPM0SOWhbyGYhy7Y2';

    $.ajax({
        type: 'GET',
        url: 'https://graph.facebook.com/v10.0/' + insta_business_id + '?fields=name%2Cmedia.limit(' + insta_media_limit + ')%7Bcaption%2Cmedia_url%2Cthumbnail_url%2Cpermalink%7D&access_token=' + insta_access_token,
        dataType: 'json',
        success: function(json) {
            var html = '';
            var insta = json.media.data;
            for (var i = 0; i < insta.length; i++) {
                var data = {
                    img: insta[i].thumbnail_url ? insta[i].thumbnail_url : insta[i].media_url,
                    caption: insta[i].caption,
                    link: insta[i].permalink
                };
                html += '<li><a href="' + data.link + '" target="_blank"><img src="' + data.img + '" alt="' + data.caption + '"></a></li>';
            }
            $("#instafeed").append(html);
        },
    });
});

// KV --- enの時リンクに/en/を付ける
//--------------------------------------------------------------------
$(function(){
  $("html[lang='en'] #slideshow-1599558550606 .btn").each(function() { 
    var replace = null;
    var replace = $(this).attr('href').replace("https://tabiji.co.jp/", "https://tabiji.co.jp/en/");
    $(this).attr('href',replace);
  });
});
